var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid press text-center p-2 mt-3 mb-3 text-light"})}
var staticRenderFns = []

export { render, staticRenderFns }